import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUsSection from '../../components/feature/WhyChooseUsSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTASection from '../../components/feature/FinalCTASection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import MidPageCTA from '../../components/feature/MidPageCTA';
import AboutHero from './components/AboutHero';
import AboutMissionSection from './components/AboutMissionSection';

const aboutFAQs = [
  {
    question: 'Who is ECOS Environmental & Disaster Restoration?',
    answer:
      'ECOS Environmental & Disaster Restoration is a certified environmental remediation company providing asbestos abatement, mold remediation, hazardous material removal, and disaster restoration across Colorado. With over 25 years of experience, they serve commercial, industrial, and government clients requiring strict regulatory compliance.',
  },
  {
    question: 'What industries does ECOS Environmental serve?',
    answer:
      'ECOS Environmental works with commercial property owners, industrial facilities, government agencies, real estate developers, healthcare facilities, and contractors across multiple sectors requiring environmental compliance and hazardous material remediation throughout Colorado.',
  },
  {
    question: 'Are you licensed and insured for environmental remediation?',
    answer:
      'Yes. ECOS Environmental operates with full state licensing, all current EPA and OSHA certifications, and comprehensive insurance coverage to meet all regulatory requirements for environmental remediation and disaster restoration work in Colorado.',
  },
  {
    question: 'How long has ECOS Environmental been in operation?',
    answer:
      'ECOS Environmental has been providing certified environmental remediation and disaster restoration services for over 25 years, completing more than 3,000 commercial, industrial, and government projects throughout Colorado and surrounding regions.',
  },
];

export default function AboutPage() {
  return (
    <main>
      <Navbar />
      <AboutHero />
      <TrustBar />
      <AboutMissionSection />
      <MidPageCTA
        headline="Ready to Work With Colorado's Top Environmental Remediation Firm?"
        subtext="Free site assessments. 24/7 emergency response. Full compliance documentation."
      />
      <AIAnswerBlock
        question="About ECOS Environmental & Disaster Restoration"
        answer="ECOS Environmental & Disaster Restoration is a licensed environmental services company specializing in remediation, hazardous material removal, disaster restoration, and compliance solutions. Their team works with commercial, industrial, and government clients to ensure safe project execution and regulatory adherence across Colorado and surrounding regions. With a mission-driven approach to safety and over 25 years of certified service, ECOS Environmental is the trusted partner for projects where precision matters most."
      />
      <ProcessSection />
      <WhyChooseUsSection headline="Experience, Certification, and Mission-Driven Safety" />
      <ServiceAreasSection />
      <TestimonialsSection />
      <MidPageCTA
        headline="Start Your Environmental Project With Confidence"
        subtext="Our certified team is ready to assess, plan, and execute — with full compliance guaranteed."
      />
      <FAQSection faqs={aboutFAQs} title="Questions About ECOS Environmental" />
      <FinalCTASection />
      <Footer />
    </main>
  );
}
